import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../shared/shared.module";
import { MyAhaMainComponent } from './components/my-aha-main/my-aha-main.component';
import { MyahaExploreComponent } from "./components/myaha-explore/myaha-explore.component";
import { ProfileCardComponent } from "./components/profile-card/profile-card.component";
import { MyAhaAnonymousComponent } from './my-aha-anonymous/my-aha-anonymous.component';
import { MyAhaComponent } from "./my-aha.component";
@NgModule({
  declarations: [
    MyAhaComponent,
    ProfileCardComponent,
    MyahaExploreComponent,
    MyAhaAnonymousComponent,
    MyAhaMainComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ],
  exports: [
    MyAhaComponent,
    MyAhaAnonymousComponent
  ]
})
export class MyAhaModule { }
